import { BoxProps, useColorModeValue } from '@chakra-ui/react';
import { useAppearance } from './AppearanceProvider';

// item 406 — THE canonical glass-panel material. This exact recipe was hand-copied
// into ~8 surfaces (grid shells, dash tiles, form scaffolds, settings cards) and had
// drifted — different opacities, radii and border weights per file, so panels on the
// same screen read as different materials. Every Aurora panel now spreads this hook;
// tune the glass HERE, never inline. The blur MUST stay the --bx-glass-panel var
// (item 322a — the single effects kill-switch), never a literal blur().
// In the Accountant skin it resolves to the flat ledger panel.
const useGlassPanel = (): BoxProps => {
  const { aurora } = useAppearance();
  const bg = useColorModeValue('rgba(255, 255, 255, 0.72)', 'rgba(255, 255, 255, 0.05)');
  // whiteAlpha.200 (was a chunky 300 on most panels): closer to the overlays'
  // hairline edges, so the glass reads thinner and more expensive
  const borderColor = useColorModeValue('gray.200', 'whiteAlpha.200');
  // light shadow raised 0.06 → 0.10 so light-mode panels separate from the canvas
  const boxShadow = useColorModeValue('0 8px 24px rgba(0, 0, 0, 0.10)', '0 8px 32px rgba(0, 0, 0, 0.45)');

  if (!aurora) {
    return {
      bg: 'ledgerSurface',
      borderWidth: '1px',
      borderColor: 'ledgerStroke',
      borderRadius: 'md',
      boxShadow: 'none',
    };
  }
  return {
    bg,
    borderWidth: '1px',
    borderColor,
    borderRadius: '2xl',
    boxShadow,
    sx: { backdropFilter: 'var(--bx-glass-panel)' },
  };
};

export default useGlassPanel;
